export default {
    collect_success: '收藏成功',
    cancel_collect_success: '取消收藏成功',
    live_no: '暂无',
    live_end: '直播已结束',
    introduction: '简介',
    reserve: '预约',
    cancel_reserve: '取消预约',
};
